<template>
	<header>
		<nav class="md:container mx-auto p-4 h-20 flex justify-between items-center">
			<HeaderBackToSite v-if="showShoppingHeader" />
			<HeaderLogo :class="{ 'mx-auto': !showShoppingHeader, '!block': !showShoppingHeader }" />
			<HeaderCartContainer v-if="showShoppingHeader" />
		</nav>
	</header>
</template>

<script setup>
	const { $configs } = useNuxtApp()
	const runtimeConfig = useRuntimeConfig()
	const appConfig = useAppConfig()

	const showMaintenancePage = runtimeConfig.public.SHOW_MAINTENANCE_PAGE
	const shouldShowMaintenancePage = $configs.$isConfigEnabled(showMaintenancePage)
	const showShoppingHeader = !shouldShowMaintenancePage && !appConfig.showMaintenancePage
</script>

<style scoped></style>
